angular.module('common')
    .factory('appInfoFactory', ['$http', function ($http) {
        function AppInfoFactory($http) {
            var self = this;
            self._http = $http;
            self._baseUrl = '/api/appinfo';
        };

        AppInfoFactory.prototype.getDateTime = function() {
            var self = this;
            return self._http.get(self._baseUrl + "/today");
        };

        AppInfoFactory.prototype.getApplicationInfo = function () {
            var self = this;
            return self._http.get(self._baseUrl);
        };

        AppInfoFactory.prototype.getSentryInfo = function () {
            var self = this;
            return self._http.get(self._baseUrl + "/sentryInfo");
        };

        return new AppInfoFactory($http);
    }]);